export const LOCAL_ST_LANGUAGE = 'LOCAL_ST_LANGUAGE';
export type LANGUAGE_ID = 'es' | 'en' | 'ca';

export const LOCAL_ST_SHOW_COVID_BALLON = 'LOCAL_ST_SHOW_COVID_BALLOON';

export enum Languages {
    ES = 'es',
    CA = 'ca',
    EN = 'en',
}

export default class LocalStorageManager {

    public static getLanguage(): string | null {
        return localStorage.getItem(LOCAL_ST_LANGUAGE);
    }

    public static setLanguage(languageId: LANGUAGE_ID): void {
        localStorage.setItem(LOCAL_ST_LANGUAGE, languageId);
    }


    public static getShowCovidBalloon(): boolean {
        const show = localStorage.getItem(LOCAL_ST_SHOW_COVID_BALLON);

        if (!show) {
            return true;
        } else {
            return show === 'true';
        }
    }

    public static setShowCovidBalloon(show: boolean): void {
        localStorage.setItem(LOCAL_ST_SHOW_COVID_BALLON, show ? 'true' : 'false');
    }
}